import { Globals } from "../CoreApp/Globals.js";

export function doApplyChartTemplate() {
  if (Globals._ctpRef == null) return;
  Globals._ctpRef.ApplyChartTemplate(Globals._ctpRef["theTemplate"]);
  Globals._ctpRef = null;
}
